import { render, staticRenderFns } from "./strengthCustomScore.vue?vue&type=template&id=14096554&scoped=true&"
import script from "./strengthCustomScore.vue?vue&type=script&lang=js&"
export * from "./strengthCustomScore.vue?vue&type=script&lang=js&"
import style0 from "./strengthCustomScore.vue?vue&type=style&index=0&id=14096554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14096554",
  null
  
)

export default component.exports